(() => {
  if (customElements.get('ns-gallery')) return;
  class NSGallery extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.ns-gallery__track');
      this.slides = [...this.querySelectorAll('.ns-gallery__track > *')];
      this.prev = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.dots = this.querySelector('[data-gallery-dots]');
      if (!this.track || !this.slides.length) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      if (this.dots) this.dots.replaceChildren();
      this.slides.forEach((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ns-gallery__dot';
        dot.setAttribute('aria-label', `Show customer story ${index + 1}`);
        if (slide.id) dot.setAttribute('aria-controls', slide.id);
        dot.addEventListener('click', () => this.goTo(index), { signal });
        this.dots?.append(dot);
      });
      this.dotButtons = [...(this.dots?.children || [])];
      this.prev?.addEventListener('click', () => this.goTo(this.index - 1), { signal });
      this.next?.addEventListener('click', () => this.goTo(this.index + 1), { signal });
      this.track.addEventListener('scroll', () => this.sync(), { passive: true, signal });
      this.sync();
    }
    offset(index) {
      return this.slides[index].offsetLeft - this.slides[0].offsetLeft;
    }
    goTo(index) {
      const target = Math.max(0, Math.min(index, this.slides.length - 1));
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.track.scrollTo({ left: this.offset(target), behavior });
    }
    sync() {
      if (!this.track || !this.slides.length) return;
      const closest = this.slides.reduce((best, slide, index) => {
        const distance = Math.abs(this.offset(index) - this.track.scrollLeft);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Infinity });
      this.index = closest.index;
      this.dotButtons?.forEach((dot, index) => dot.setAttribute('aria-pressed', String(index === this.index)));
      if (this.prev) this.prev.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === this.slides.length - 1;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('ns-gallery', NSGallery);
})();
